import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';
import router from '@/plugins/router';

// 查询底材列表
export const queryBasematerials: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setBasematerials', { ...state.list, loading: true });
    // const res = await $http.get('/material/type/item/basematerials');
    const res = await $http.get('/v1/asset/material/basemat/list');
    commit('setBasematerials', { data: res });
  } catch (e) {
    commit('setBasematerials', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询底材详情
export const queryBasematerialDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setBasematerialDetail', { data: null, loading: true });
    // const res = await $http.get(`/material/type/item/basematerial/view/${payload}`);
    const res = await $http.get(`/v1/asset/material/basemat/${payload}/detail`);
    commit('setBasematerialDetail', { data: res, loading: false });
  } catch (e) {
    commit('setBasematerialDetail', { data: null, loading: false });
  }
};

// 添加底材
export const addBasematerial: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/material/type/item/basematerial/add', payload);
    await $http.post('/v1/asset/material/basemat/add', payload);
    store.commit('common/setToast', { visible: true, text: '添加成功' });
    await router.push({ name: 'materials-basematerial' });
  } finally {
    commit('setLoading', false);
  }
};

// 编辑底材
export const editBasematerial: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/material/type/item/basematerial/modify', payload);
    await $http.post('/v1/asset/material/basemat/modify', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
    await router.push({ name: 'materials-basematerial' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除底材
export const deleteBasematerial: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/material/type/item/basematerial/delete', payload);
    await $http.post('/v1/asset/material/basemat/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
